import axios from 'axios';

async function getSystemStatus(filter) {
  const url = 'SystemStatus';
  const request = {
    method: 'GET',
    url: url,
    params: filter,
  };

  const res = await axios(request);
  return res.data;
}

async function getSystemStatusAllGroupNames() {
  const url = 'SystemStatus/groupNames';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSystemStatusInfoTypes() {
  const url = 'SystemStatus/infoTypes';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSystemStatusDetails(id, filter) {
  const url = 'SystemStatus/' + id;
  const request = {
    method: 'GET',
    url: url,
    params: filter,
  };

  const res = await axios(request);
  return res.data;
};

async function getSystemStatusById(id) {
  try {
    const url = 'SystemStatus/ById/' + id;
    const request = {
      method: 'GET',
      url: url,
    };

    const res = await axios(request);
    return res.data;
  }
  catch {
    return null;
  }
};




const SystemStatusService = {
  API: {
    getSystemStatus,
    getSystemStatusAllGroupNames,
    getSystemStatusInfoTypes,
    getSystemStatusDetails,
    getSystemStatusById,
  },
};

export default SystemStatusService;